<div class="container-fluid padding-lg-top padding-xl-bottom">
    <div class="container">
        <app-resource resourceIdentifier="{{resourceIdentifier}}" [showActions]="false"></app-resource>
    </div>
</div>
